<template>
  <div class="pull-right" style="margin-top: 10px; margin-bottom: 10px">
    <button v-if="showCSV" class="btn btn-default" v-on:click="exportCsv">{{ whatIsExported }} als CSV exportieren</button>
    <button v-if="showXLSX" class="btn btn-default" v-on:click="exportXlsx">{{ whatIsExported }} als Excel exportieren</button>
  </div>
</template>

<script>
import exportCsv from './_utils/exportCsv.js'
import exportXls from './_utils/exportXls.js'
import api from '@/api.js'
import helpers from '@/mixins/helper-functions'

export default {
  name: 'ExportButtons',
  props: {
    columns: Array,
    query: Object,
    config: Object,
    selection: Array
  },
  data () {
    return {
      showCSV: false,
      showXLSX: true
    }
  },
  computed: {
    whatIsExported () {
      return (this.selection.length) ? 'Ausgewählte Zeilen ' : 'Alles '
    },
    postResource () {
      return helpers.getPostResource(this.$route)
    },
    exportQuery () {
      var exportQuery = JSON.parse(JSON.stringify(this.query))
      exportQuery.limit = undefined
      return exportQuery
    },
    visibleColumns () {
      return this.columns.filter(col => col.visible && col.title !== 'Bilder').map(col => col.title)
    },
    dbToLabel () {
      return helpers.englishToGerman(this.config)
    }
  },
  methods: {
    async getExportData () {
      // Export selection
      // If selection is empty, fetch data from database
      var exportData
      if (this.selection.length) {
        exportData = this.selection
      } else {
        exportData = await api.getPosts(this.postResource, this.exportQuery)
        exportData = (this.postResource.includes('medication')) ? helpers.transformDBToTable(exportData.result.rows) : exportData.result.rows
      }

      // Rename column names
      exportData = exportData.map(row => {
        // Augmenting rows isn't necessary any more, as this happens on server side!
        var newRow = {}
        for (var key in row) {
          if (Array.isArray(row[key])) {
            newRow[this.dbToLabel[key]] = row[key].join(', ')
          } else {
            newRow[this.dbToLabel[key]] = row[key]
          }
        }
        return newRow
      })
      return exportData
    },
    async exportCsv () {
      var exportData = await this.getExportData()
      exportCsv(exportData, this.visibleColumns, 'export_' + this.postResource)
    },
    async exportXlsx () {
      var exportData = await this.getExportData()
      exportXls(exportData, this.visibleColumns, 'export_' + this.postResource)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Datatable/src/ExportButtons.vue